export default [
    {
        path: '/prerequisite/part-types',

        name: 'Part Types',

        component: () => import('@/views/prerequisite/part-types'),
    },
];